module.exports = __webpack_public_path__ + "static/media/ravenclaw gif.e868ee95.gif";